class HelperCollections {

    static handleChange(newOcc, index, props) {
        var list = [];
        var iniList = props.data != null ? props.data : [];
        for (var key in iniList) {
            var occ = iniList[key];
            if (key - index === 0) {
                list.push(newOcc);
            } else {
                list.push(occ);
            }
        }
        props.onChange(list);
    }
    static handleDelete(code, codeName, props) {
        var list = [];
        var iniList = props.data != null ? props.data : [];
        for (var key in iniList) {
            var occ = iniList[key];
            if (occ[codeName] !== code) {
                list.push(occ);
            }
        }
        props.onChange(list);
    }
    static handleAdd(codeName, props, defaultValue) {
        var list = props.data != null ? [...props.data] : [];
        var size = list.length * 1 + 1;
        var record = {};
        if (!defaultValue) {
            record[codeName] = `new${size}`;
        } else {
            record[codeName] = defaultValue;
        }
        list.push({ ...record });
        props.onChange(list);
    }
    static handleCopy(code, codeName, props) {
        var list = props.data != null ? [...props.data] : [];
        var size = list.length * 1 + 1;
        var occCopy = null;
        for (var key in list) {
            var occ = list[key];
            if (occ[codeName] === code) {
                occCopy = { ...occ };
            }
        }
        if (occCopy != null) {
            occCopy[codeName] = `new${size}`;
            list.push(occCopy);
            props.onChange(list);
        }
    }
}

export default HelperCollections
